import { Stat } from "@keel/ui";

/** Home dashboard: items at or below their reorder point. */
export function LowStockTile({ data }: { data: { lowStock: number; items: { sku: string }[] } }) {
  return (
    <Stat
      label="Low stock"
      value={data.lowStock}
      href="/inventory?low=1"
      tone={data.lowStock ? "warn" : undefined}
      foot={
        data.lowStock
          ? data.items
              .map((i) => i.sku)
              .slice(0, 3)
              .join(", ")
          : "Everything above its reorder point"
      }
    />
  );
}
